import styled from "styled-components";
import {ListGroup, ListGroupItem} from "react-bootstrap";


export const LinkComponentContainer = styled.div``


export const LinkComponentLink = styled.div`
display: grid;
  grid-template-columns: 10px 10px 1fr 10px;
  gap: 15px;
  justify-items: left;
  align-items: center;
  max-width: 600px;
  button {
    text-align: start;
  }
`


export const LinkComponentListGroup = styled.div`
  padding: 7px;
  display: grid;
  gap: 10px;
  align-items: center;
  grid-template-columns: 1fr 20px;
  width: 100%;

  p {
    margin: 0;
    padding: 0;
  }
`
